import { trackingApi } from "@/core/data/api";

export default async (trackingId, trackingData) => {
  return await trackingApi.createTracking(trackingId, trackingData);
};
